
import { RectangleStencil, CircleStencil } from "vue-advanced-cropper"

export default {
    name: "Stencil",
    components: {
        RectangleStencil,
    },
    props: {
        moveHandler: {
            type: Function,
        },
        round: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        stencil() {
            return this.round ? CircleStencil : RectangleStencil
        },
    },
    methods: {
        onChange() {
            if (this.moveHandler) {
                this.moveHandler(true)
            }
        },
        onChangeEnd() {
            if (this.moveHandler) {
                this.moveHandler(false)
            }
        },
    },
}
